<template>
    <div class="full-table-outer">
        <div class="full-table-inner" :style="containerStyle">
            <table ref="full-table" class="full-table" :style="tableStyle">
                <thead>

                <!-- Headers -->
                <tr class="full-table-head" :class="headerClass" id="items">
                    <th class="full-table-cell sort-item" @click="setSort(col)" v-for="col in sortedCols" :key="col.key" :id="col.key" :style="col.style" :class="{fixed: col.fixed}" v-show="isSelected(col)">
                        <slot :name="col.key + '_heading'" :value="col.display" :data="col">
                            {{col.display}}
                        </slot>
                        <i class="fa" v-show="isSorting(col.key)" :class="[getSortDir(col.key) == 'ASC'? 'fa-angle-up': 'fa-angle-down']" />
                    </th>
                </tr>

                <!-- Filters -->
                <tr slot="filters" class="full-table-filters" :class="filterClass"  v-show="!sorting" >
                    <td class="full-table-cell" v-for="col in sortedCols" :key="col.key" :style="col.style" :class="{fixed: col.fixed}" v-show="isSelected(col)">
                        <slot :name="col.key + '_filter'" :value="col.key" :data="col">
                            <input
                                    v-show="col.filter"
                                    type="text"
                                    :class="filterInputClass"
                                    v-model="filters.search[col.key]"
                            />
                        </slot>
                    </td>
                </tr>
                </thead>

                <tbody>
                <!-- Data -->
                <tr v-for="d, i in data" class="full-table-row" v-show="!sorting" >
                    <td class="full-table-cell" v-for="col in sortedCols" :key="col.key" :style="col.style" :class="{fixed: col.fixed}" v-show="isSelected(col)">
                        <slot :name="col.key + '_data'" :value="d[col.key]" :data="d" :index="i" :count="data.length">
                            {{d[col.key] || '-'}}
                        </slot>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <slot name="loading" style="text-align:center;" ></slot>

    </div>
</template>
<script type="text/babel">
    import Sortable from 'sortablejs'

    export default{
        name: "FullTable",
        props: {
            cols: {
                required: true,
                type: Array,
                default: []
            },
            data:{
                required: false,
                type: Array,
                default: []
            },
            filters:{
                required: false,
                type: Object
            },
            filterClass:{
                required: false,
                type: String
            },
            filterInputClass:{
                required: false,
                type: String
            },
            headerClass:{
                required: false,
                type: String
            },
        },
        data(){
            return{
                tableStyle:{
                    width: 'auto'
                },
                containerStyle:{
                    left: 0
                },
                sorting:false
            }
        },
        created(){
            //this.setWidths();
            this.setFilters();
            this.setSearch(this.$route);



        },
        computed:{
            sortedCols(){
                this.cols.sort(function(a,b){
                    return a.sort - b.sort
                });
                return this.cols;
            }
        },

        methods:{
            isSelected(col){
                return this.filters.columns.length && this.filters.columns.indexOf(col.key) >= 0;
            },
            filter(){
                this.$emit('filter', this.filters);
            },
            setFilters(){
                var _this = this;
                this.cols.forEach(function(c){
                    if(c.filter){
                        _this.$set(_this.filters.search, c.key, _this.filters.search[c.key] || '');
                    }
                });

                _this.$set(_this.filters, 'sort', _this.filters.sort);
            },
            setWidths(){
                var _this = this;
                var totalFixed = 0;

                var columns = this.cols.filter(function(c){
                    return !_this.filters.columns || !_this.filters.columns.length || _this.filters.columns.indexOf(c.key) >= 0
                });

                var totalWidth = columns.reduce(function(a, b){
                    return a + ( b.width || 200);
                }, 0);


                columns.forEach(function(c){
                    if(_this.filters.columns && _this.filters.columns.length && _this.filters.columns.indexOf(c.key) < 0) {
                        c.style.width = '0px';
                        c.style.left = '0px';
                    } else {
                        c.style = c.style || {};
                        c.width = c.width || 200;
                        if(c.fixed){
                            c.style.width = c.width + 'px';
                            c.style.left = totalFixed + 'px';
                            totalFixed += c.width;
                        } else if(c.width){
                            c.style.minWidth = c.width + 'px';
                            c.style.width = ((c.width / totalWidth) * 100) + "%"
                        }

                    }

                });

                this.containerStyle.left = totalFixed + 'px';
                this.tableStyle.width = totalWidth + 'px';

            },
            setSort(col){

                if(col.sortable){
                    var val = col.key;
                    var index;
                    var field = this.filters.sort.filter(function(s, i){
                        if(s.field == val){
                            index = i;
                            return true;
                        }
                    });

                    if(!field.length) return this.filters.sort.push({field: val, dir: 'ASC'});
                    if(field[0].dir == 'ASC') return  this.$set(this.filters.sort, index, {
                        field: val,
                        dir: 'DESC'
                    } );
                    if(field[0].dir == 'DESC') return this.filters.sort.splice(index, 1);

                    this.filter();
                }
            },
            isSorting(val){
                this.filters.sort = this.filters.sort || [];
                return this.filters.sort.filter(function(s, i){
                    return s.field == val;
                }).length;
            },
            getSortDir(val){
                return this.filters.sort.filter(function(s, i){
                    return s.field == val;
                }).map(function(s){
                    return s.dir;
                })[0]
            },

            search(){

                var str = '?';
                for (var key in this.filters.search) {
                    if (str != "?") {
                        str += "&";
                    }
                    if( this.filters.search[key] !== null && ( typeof this.filters.search[key] === 'object' || Array.isArray(this.filters.search[key]) )){
                        str += key + "=" + encodeURIComponent(JSON.stringify(this.filters.search[key]));
                    } else {
                        str += key + "=" + encodeURIComponent(this.filters.search[key]);
                    }
                }

                var allCols = [];

                if(this.filters.columns.length){
                    allCols = this.filters.columns;
                } else {
                    allCols = this.cols.filter( c => !c.hide ).map(c => c.key);
                }

                str += "&columns=" +  encodeURIComponent(JSON.stringify(allCols));


                str += '&sort=' + encodeURIComponent(JSON.stringify(this.filters.sort));


                str += '&page=' + this.filters.page;
                str += '&limit=' + encodeURIComponent(this.filters.limit);
                this.setWidths();

                this.$router.push(this.$route.path + str);
            },
            setSearch(to){
                var _this = this;

                var filters = _this.filters ||  {
                    search:{},
                    sort:{},
                    columns:[],
                    page:1,
                    limit: 25
                };

                this.cols.forEach(function(col){
                    if(col.key in to.query){
                        if(col.filter && col.filter == 'Array'){
                            try{
                                filters.search[col.key] = JSON.parse(to.query[col.key]);
                            } catch(err){
                                filters.search[col.key] = [];
                            }
                        } else if(col.filter && col.filter == 'Object'){
                            try{
                                filters.search[col.key] = JSON.parse(to.query[col.key]);
                            } catch(err){
                                filters.search[col.key] = {};
                            }
                        } else {
                            filters.search[col.key] =  to.query[col.key] || "";
                        }
                    }
                });

                try{
                    filters.sort = to.query.sort? JSON.parse(to.query.sort): filters.sort;
                } catch(err){

                    filters.sort =  [];
                }

                try{
                    filters.columns = JSON.parse(to.query.columns);
                } catch(err){
                    console.log(err);
                }

                filters.limit = to.query.limit || filters.limit;
                filters.page = to.query.page || filters.page;


                this.$emit('filter', filters);
            },
            sortColumns(){
                var _this = this;
                var ancestor = document.getElementById('items'),
                        descendents = ancestor.getElementsByTagName('th');
                var i, e;
                for (i = 0; i < descendents.length; ++i) {
                    e = descendents[i];
                    _this.cols.forEach(function(c, j){
                        if(c.key == e.id){
                            _this.cols[j].sort = i;
                        }
                    });
                }
            }
        },
        mounted(){
            var el = document.getElementById('items');
            var _this = this;
            var sortable = Sortable.create(el, {
                animation: 150,
                onSort: function (evt) {
                    _this.sortColumns()
                },
                onStart: function (evt) {
                    _this.sorting = true;
                },
                onEnd: function (evt) {
                    _this.sorting = false;
                }
            });
        },
        watch: {
            "filters": {
                handler: _.debounce(function(){
                    this.search();
                }, 0),
                deep: true
            },
            '$route' (to, from) {
                this.setSearch(to);
            },
            'cols' (to, from) {
                this.setWidths();
                this.setFilters();
            }
        }


    }

</script>
<style>

    .full-table-outer {
        width: 100%;
        position:relative
    }


    .full-table-outer .full-table{
        min-width: 100%;
    }

    .full-table-outer .full-table-row,
    .full-table-outer .full-table-filters,
    .full-table-outer .full-table-head{
        border-top: 1px solid #e2e2e2;
    }


    .full-table-outer .full-table-inner {
        overflow-x:scroll;
        overflow-y:visible;
        min-width: 100%;

    }

    .full-table-outer td, .full-table-outer th {
        vertical-align: top;
    }

    .full-table-outer table{
        table-layout: fixed;
        width: 100%;
    }
    .full-table-outer .full-table-cell{
        padding: 5px 15px;
    }
    .full-table-outer .full-table-filters .full-table-cell.fixed,
    .full-table-outer .full-table-row .full-table-cell.fixed,
    .full-table-outer .full-table-head .full-table-cell.fixed {
        position: absolute;
        z-index: 1000;
    }
    .full-table-outer .full-table-row .full-table-cell.fixed{
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

    }
    .full-table-outer .full-table-filters .full-table-cell.fixed{
        z-index: 2000;
    }

    .full-table-head .full-table-cell.sort-item{
        cursor: move;
    }


</style>


// WEBPACK FOOTER //
// FullTable.vue?06dcdf30